exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".device-table td,.device-table thead th{vertical-align:middle!important;text-align:center!important}#submissionModule .modal-dialog{max-width:1024px!important}#submissionModule .modal-body{height:500px!important}.my-editor{background:#fff;color:#ccc;font-family:Fira code,Fira Mono,Consolas,Menlo,Courier,monospace;font-size:14px;line-height:1.5;padding:5px}.prism-editor__textarea:focus{outline:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1eec7647","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./resources/js/components/Submission.vue
// module id = 709
// module chunks = 0